module.exports = __webpack_public_path__ + "img/arrowRight.0e1fdc5.png";